import { useApp } from "../../context/App";
import { TitlePage } from "../../components/ui/TitlePage";
import { Home, ArrowLeft, SearchX } from "lucide-react";
import { useNavigate } from "react-router-dom";

export function NotFoundScreen() {

	const { configDomainURL } = useApp()
	const navigate = useNavigate();

	const goBack = () => {
		if (window.history.length > 1) {
			navigate(-1);
		} else {
			window.location.href = configDomainURL;
		}
	}
	return (
		<div className="flex flex-col w-full min-h-screen bg-white dark:bg-surface-dark transition-colors items-center justify-start font-roboto">

			<TitlePage title={'Erro 404 - Página não encontrada'} />

			<div className="flex-1 w-11/12 mx-auto lg:w-3/5 mt-8 lg:mt-16 mb-20 flex flex-col items-center justify-center text-center">
				<div className="w-24 h-24 lg:w-32 lg:h-32 bg-primary/10 dark:bg-primary-light/10 rounded-full flex items-center justify-center mb-6 shadow-inner ring-4 ring-primary/5 dark:ring-primary-light/5">
					<SearchX className="w-12 h-12 lg:w-16 lg:h-16 text-primary dark:text-primary-light stroke-[1.5]" />
				</div>

				<h2 className="text-3xl lg:text-4xl font-extrabold text-gray-900 dark:text-white mb-4 tracking-tight">
					Ops... Este endereço está errado ou não existe
				</h2>

				<p className="text-base lg:text-lg text-gray-600 dark:text-gray-400 max-w-2xl mb-8 leading-relaxed">
					Não conseguimos encontrar a página que você está procurando no caminho <br className="hidden lg:block" />
					<code className="inline-block mt-2 bg-gray-100 dark:bg-surface-dark-alt tracking-wide font-mono px-3 py-1.5 rounded-lg border border-gray-200 dark:border-border-dark text-primary dark:text-primary-light text-sm break-all">
						{window.location.href}
					</code>
				</p>

				<div className="flex flex-col sm:flex-row items-center justify-center gap-4 w-full sm:w-auto">
					<button
						onClick={goBack}
						className="w-full sm:w-auto flex items-center justify-center gap-2 px-6 py-3.5 bg-white dark:bg-surface-dark-alt text-on-surface dark:text-on-surface-dark border border-border-default dark:border-border-default-dark rounded-xl font-bold text-sm tracking-wide hover:bg-gray-50 dark:hover:bg-gray-800 transition-colors cursor-pointer shadow-sm active:scale-95"
					>
						<ArrowLeft size={18} strokeWidth={2.5} />
						Voltar
					</button>

					<button
						onClick={() => window.location.href = configDomainURL}
						className="w-full sm:w-auto flex items-center justify-center gap-2 px-6 py-3.5 bg-primary dark:bg-primary-light text-white rounded-xl font-bold text-sm tracking-wide hover:bg-primary-dark dark:hover:bg-primary transition-colors cursor-pointer shadow-md active:scale-95"
					>
						<Home size={18} strokeWidth={2.5} />
						Ir para o Início
					</button>
				</div>
			</div>

		</div>
	)

}